import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=faf304d0&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports